module.exports = __webpack_public_path__ + "static/media/icon_date.5f473a57.svg";